
import request from '../untils/request';

export const workingOrdersListApi = params => {
  return request({
    url: '/work/work-order/index',
    params,
  });
};

export const workingOrdersConfigsApi = params => {
  return request({
    url: '/work/work-order-class/index',
    params,
  });
};

export const workingOrdersUsersListApi = params => {
  return request({
    url: '/work/work-order-class/user-list',
    params,
  });
};

export const workingOrdersUsersListWithSelfApi = params => {
  return request({
    url: '/work/work-order-class/user-list-has-self',
    params,
  });
};

export const workingOrdersConfigSaveApi = params => {
  return request({
    url: '/work/work-order-class/save',
    params,
  });
};

export const workingOrdersConfigOperateApi = params => {
  return request({
    url: '/work/work-order-class/operate',
    params,
  });
};

export const workingOrdersPendingListApi = params => {
  return request({
    url: '/work/work-order/pending',
    params,
  });
};

export const workingOrdersAboutMeApi = params => {
  return request({
    url: '/work/work-order/me',
    params,
  });
};

export const workingOrdersAllApi = params => {
  return request({
    url: '/work/work-order/all',
    params,
  });
};

export const workingOrdersClassListApi = params => {
  return request({
    url: '/work/work-order/class-list',
    params,
  });
};

export const workingOrdersCreateApi = params => {
  return request({
    url: '/work/work-order/create',
    params,
  });
};

export const workingOrdersRemindApi = params => {
  return request({
    url: '/work/work-order/reminder',
    params,
  });
};

export const workingOrdersDetailApi = params => {
  return request({
    url: '/work/work-order/detail',
    params,
  });
};

export const workingOrdersDetailMsgListApi = params => {
  return request({
    url: '/work/work-order/msg-list',
    params,
  });
};

export const workingOrdersSendApi = params => {
  return request({
    url: '/work/work-order/send',
    params,
  });
};

export const workingOrdersTransApi = params => {
  return request({
    url: '/work/work-order/trans',
    params,
  });
};

export const workingOrdersCompleteApi = params => {
  return request({
    url: '/work/work-order/complete',
    params,
  });
};

export const workingOrdersTabNumsApi = params => {
  return request({
    url: '/work/work-order/tab-num',
    params,
  });
};
